module.exports = __webpack_public_path__ + "static/scale-model-of-the-old-ywca-building-in-pasadena-california-e4cdff74726a9bfac16fc5d81287d18d.png";